module.exports = __webpack_public_path__ + "static/media/sata-logo.64c2e02c.svg";